module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "analytics"
    }
  }, [_c('v-panel', {
    staticClass: "analytic_w"
  }, [_c('div', {
    staticClass: "page-header-wrapper",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "analytic_filter_area white"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2 col-md-3"
  }, [_c('div', {
    staticClass: "booking_tle text-uppercase d-flex align-items-center"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/notebook.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('analytics.index.title')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-lg-10"
  }, [_c('div', {
    staticClass: "dropdown dropdown_btn right"
  }, [_c('button', {
    staticClass: "btn btn-bold btn-red waves-effect waves-classic btn-with-caret ",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("button.actions")) + "\n                  "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.generateConcierge.openConciergeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.generate_concierge')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.generateAnalyses.generateAnalyses()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.export_super_analyses_results')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.generateExtractor.generateExtractor()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.generate_super_extractor_results')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.generateCityTaxes.openCityTaxesModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.generate_city_taxes')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-auto filter-by-rental right m-r-20"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-lg dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('booking.index.filter_by_rental')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu rental-group-ul",
    attrs: {
      "aria-labelledby": "navbarDropdown"
    }
  }, _vm._l((_vm.groups), function(group) {
    return (group.rentals.length > 0) ? _c('ul', {
      staticClass: "checkbox-custom m-l-30 checkbox-primary rental-group-ul",
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedGroups[group.id]),
        expression: "checkedGroups[group.id]"
      }],
      attrs: {
        "type": "checkbox",
        "id": group.name,
        "disabled": _vm.generalLoading
      },
      domProps: {
        "checked": Array.isArray(_vm.checkedGroups[group.id]) ? _vm._i(_vm.checkedGroups[group.id], null) > -1 : (_vm.checkedGroups[group.id])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.checkedGroups[group.id],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.checkedGroups, group.id, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.checkedGroups, group.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.checkedGroups, group.id, $$c)
          }
        }, function($event) {
          _vm.filterByRentals(group.id)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": group.name
      }
    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _vm._l((group.rentals), function(rental) {
      return _c('li', {
        staticClass: "checkbox-custom m-l-10 checkbox-inline checkbox-primary dropdown-item"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.checkedRentals[rental.id]),
          expression: "checkedRentals[rental.id]"
        }],
        attrs: {
          "type": "checkbox",
          "id": rental.name,
          "disabled": _vm.generalLoading
        },
        domProps: {
          "checked": Array.isArray(_vm.checkedRentals[rental.id]) ? _vm._i(_vm.checkedRentals[rental.id], null) > -1 : (_vm.checkedRentals[rental.id])
        },
        on: {
          "change": [function($event) {
            var $$a = _vm.checkedRentals[rental.id],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.checkedRentals, rental.id, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.checkedRentals, rental.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.checkedRentals, rental.id, $$c)
            }
          }, function($event) {
            _vm.filterByRentals()
          }]
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": ("rental-" + (rental.id))
        }
      }, [_c('span', [_vm._v("\n                             " + _vm._s(rental.name) + "\n                          ")])])])
    })], 2) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "analytic_filter analytic_filter2"
  }, [_c('div', {
    staticClass: "right d-flex justify-content-center align-items-center"
  }, [_c('label', {}, [_vm._v(_vm._s(_vm.$t('analytics.index.period')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    staticClass: "form-control year-period right",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getGeneralAnalyticData(_vm.getCheckedRentalIds(_vm.checkedRentals), _vm.year, _vm.month)
      }]
    }
  }, _vm._l((_vm.yearRange), function(year) {
    return _c('option', [_vm._v(_vm._s(year))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.month),
      expression: "month"
    }],
    staticClass: "form-control month-period",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.month = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getGeneralAnalyticData(_vm.getCheckedRentalIds(_vm.checkedRentals), _vm.year, _vm.month)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[0]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[1]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[2]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[3]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[4]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[5]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[6]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[7]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[8]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[9]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[10]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v(_vm._s(_vm.$t('months')[11]))])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-tabs"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [(_vm.accessToTabsStatus.general) ? _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('general')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("analytics.index.general")))]) : _vm._e(), _vm._v(" "), (_vm.accessToTabsStatus.reviews) ? _c('li', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('reviews')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("analytics.index.reviews")))]) : _vm._e(), _vm._v(" "), (_vm.accessToTabsStatus.environment) ? _c('li', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('environment')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("analytics.index.environment")))]) : _vm._e(), _vm._v(" "), (_vm.accessToTabsStatus.market) ? _c('li', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('market')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("analytics.index.market")))]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.generalLoading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.generalLoading),
      expression: "!generalLoading"
    }]
  }, [_c('div', {
    staticClass: "analytics-lead"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Informations sur votre tableau de bord financier")]), _vm._v(" "), _c('p', [_vm._v("Superhote n'est pas une solution de comptabilité. La fonction Analytics vous permet d'avoir une vue globale de la performance financière de vos annonces.\n              "), _c('br'), _vm._v("Les résultats sont affichés sur une base mensuelle du 1er au dernier jour du mois.\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rentals.length === 0),
      expression: "rentals.length === 0"
    }],
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "list-rental-empty"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t("rentals.index.no_result")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup ",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openImportNewRentalsModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.setup")))])])]), _vm._v(" "), _c('v-import-new-airbnb-rentals', {
    ref: "airbnbImportModal"
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rentals.length > 0),
      expression: "rentals.length > 0"
    }]
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "title_count"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "list-icon",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/list.svg",
      "alt": "NO IMAGE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.getCheckedRentalIds(_vm.checkedRentals).length !== 0 ? _vm.getCheckedRentalIds(_vm.checkedRentals).length : _vm.rentals.length))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.rentals.length > 1 ? _vm.$t('analytics.index.active_listing_plural') : _vm.$t('analytics.index.active_listing')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/coin-euro.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.nightsSold))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.nights_sold')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover analytics-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('analytics.tooltips.night_sold')
    }
  })])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cart.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.nightsToSell))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.nights_to_sell')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/clock.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s((_vm.occupancy).toFixed(2)) + " %")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.occupancy')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/users2.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.avgGuestCount.toFixed(2)))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.avg_no_of_guests')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "title_count"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/book3.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.avgNightBooked.toFixed(2)) + " ")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.avg_night_booked')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cash3.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.avgPayout.toFixed(2)) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.avg_payout')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover analytics-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('analytics.tooltips.avg_payout_per_booking')
    }
  })])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cash3.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.nightsSold !== 0 ? (_vm.totalIncomePerMonth / _vm.nightsSold).toFixed(2) : 0) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.rev_par')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover analytics-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('analytics.tooltips.rev_par')
    }
  })])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/clock.svg",
      "alt": "NO IMAGE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.occupancyWithoutBlockedDates >= 0 ? parseFloat(_vm.occupancyWithoutBlockedDates).toFixed(2) : 0) + " %")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.occupancy_per_night')) + " ")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/wallet.svg",
      "alt": "NO IMAGE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalIncomePerMonth) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.total_income')) + "\n                                        "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "200"
    }
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.total_income_sub')))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "title_count"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cash3.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.totalCommissionPerMonth.toFixed(2)) + "  " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.commissions_per_day')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cash3.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalNetIncomePerMonth.toFixed(2)) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.net_income_per_day')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover analytics-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('analytics.tooltips.net_income')
    }
  })])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cash3.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalCityTaxesPerMonth.toFixed(2)) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.city_taxes_per_day')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover analytics-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('analytics.tooltips.city_taxes')
    }
  })])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cash3.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalCleaningFeesPerMonth.toFixed(2)) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('input.cleaning_fees')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover analytics-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('analytics.tooltips.cleaning_fees')
    }
  })])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon col-xxl-5"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    staticClass: "analytic-icons",
    attrs: {
      "src": "static/assets/images/SuperHote_icons/book3.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont col-xxl-7"
  }, [_c('h3', [_vm._v(_vm._s(Math.trunc(_vm.nbrCheckingCheckout)))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "d-inline"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.nbr_checkins_checkouts')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover analytics-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-placement": "left",
      "data-content": _vm.$t('analytics.tooltips.nbr_checkins_checkouts')
    }
  })])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "left_analytic "
  }, [_c('div', {
    staticClass: "channel_overview clearfix h-full"
  }, [_c('div', {
    staticClass: "x_tle"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.channel_overview')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 chartPar"
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.datasetsData.length == 0),
      expression: "datasetsData.length == 0"
    }],
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.chart_no_data_message')))]), _vm._v(" "), _c('div', {
    staticClass: "x_content col-xxl-6 col-xl-9"
  }, [_c('canvas', {
    staticClass: "chart",
    attrs: {
      "id": "channel-overview"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "x_content_dtls col-xxl-6"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', _vm._l((_vm.channels), function(channel, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.datasetsData.length > 0),
        expression: "datasetsData.length > 0"
      }]
    }, [_c('td', [_c('i', {
      class: 'fa fa-circle' + index,
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(index))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(((_vm.channels[index] / _vm.nightsSold) * 100).toFixed(2)) + "%")])])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 chartPar"
  }, [(_vm.channelsIncomeDatasetsData.length === 0) ? _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('analytics.index.chart_no_data_message')) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "x_content col-xxl-6 col-xl-9"
  }, [_c('canvas', {
    staticClass: "chart",
    attrs: {
      "id": "channel-income-per-month"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "x_content_dtls col-xxl-6"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', _vm._l((_vm.channelsIncomePerMonth), function(channelIncome, index) {
    return (_vm.channelsIncomeDatasetsData.length > 0) ? _c('tr', [(channelIncome > 0) ? _c('td', [_c('i', {
      class: 'fa fa-circle' + index,
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(index))]) : _vm._e(), _vm._v(" "), (channelIncome > 0) ? _c('td', [_c('span', [_vm._v(_vm._s(((parseFloat((channelIncome).toFixed(2))) + " " + (_vm.account.currency.symbol) + " ")))])]) : _vm._e()]) : _vm._e()
  }))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "right_analytic "
  }, [_c('div', {
    staticClass: "channel_overview clearfix"
  }, [_c('div', {
    staticClass: "x_tle"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.occupied')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 chartPar"
  }, [_c('div', {}, [_c('canvas', {
    staticClass: "chart",
    attrs: {
      "id": "occupancy-chart"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "channel_overview clearfix mt-20"
  }, [_c('div', {
    staticClass: "x_tle"
  }, [_vm._v(_vm._s(_vm.$t('analytics.index.total_income')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 chartPar"
  }, [_c('div', {}, [_c('canvas', {
    staticClass: "chart",
    attrs: {
      "id": "income-chart"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mt-20"
  }, [_c('div', {}, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    staticClass: "counting_deatils"
  }, [_c('table', {
    staticClass: "table table-hover table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('analytics.index.period')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('analytics.index.nights_booked')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('analytics.index.empty_nights')))]), _vm._v(" "), _c('th', [_vm._v("% " + _vm._s(_vm.$t('analytics.index.occupied')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('analytics.index.commissions_per_day')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('analytics.index.city_taxes_per_day')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('analytics.index.total_income')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('analytics.index.net_income_per_day')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.analyticTableData), function(analyticTable, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('months[' + index + ']')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(analyticTable.nightsSold))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(analyticTable.nightsToSell))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((analyticTable.occupancy).toFixed(2)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s((analyticTable.commission).toFixed(2)) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((analyticTable.cityTaxes).toFixed(2)) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((analyticTable.income).toFixed(2)) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((analyticTable.netIncome).toFixed(2)) + " " + _vm._s(_vm.user.currency.symbol))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "total"
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.totalNightsSold.toFixed(2)))]), _vm._v(" "), _c('td', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.totalNightsToSell.toFixed(2)))]), _vm._v(" "), _c('td', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.totalOccupancy.toFixed(2)) + " %")]), _vm._v(" "), _c('td', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.totalCommissions) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('td', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.totalCityTaxes) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('td', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.totalIncome) + " " + _vm._s(_vm.user.currency.symbol))]), _vm._v(" "), _c('td', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.totalNetIncome) + " " + _vm._s(_vm.user.currency.symbol))])])], 2)])])])])])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('v-generate-city-taxes', {
    ref: "generateCityTaxes",
    attrs: {
      "rentals": _vm.rentals,
      "groups": _vm.groups
    }
  }), _vm._v(" "), _c('v-export-analysis', {
    ref: "exportAnalysis",
    attrs: {
      "rentals": _vm.rentals,
      "email": _vm.account.email,
      "groups": _vm.groups
    }
  }), _vm._v(" "), _c('v-generate-concierge', {
    ref: "generateConcierge",
    attrs: {
      "rentals": _vm.rentals,
      "email": _vm.account.email,
      "groups": _vm.groups
    }
  }), _vm._v(" "), _c('v-generate-analyses', {
    ref: "generateAnalyses",
    attrs: {
      "email": _vm.account.email
    }
  }), _vm._v(" "), _c('v-generate-extractor', {
    ref: "generateExtractor"
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fc2819a"}!./src/app/pages/analytics/general/general.html
// module id = 1371
// module chunks = 0